import React from "react";
import { useTranslation } from "react-i18next";
import { IoIosLock } from "react-icons/io";
import { useDispatch } from "react-redux";
import { Modal, ModalBody } from "reactstrap";

import { TokenisationConfirmModalProps } from "@models/components/modals.model";
import bookingSlice from "@slices/booking.slice";

export const TokenisationConfirmModal: React.FC<
  TokenisationConfirmModalProps
> = ({ isOpen, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(bookingSlice.actions.setShowPaymentCancelWarning(true));
    onCancel();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleCancel}
      centered
      size="md"
      contentClassName="fg-tok-confirm-modal-content"
    >
      <ModalBody className="fg-tok-confirm-modal-body">
        <div className="fg-tok-confirm-icon-wrap">
          <IoIosLock className="fg-tok-confirm-icon" />
        </div>

        <h4 className="fg-tok-confirm-message">
          {t("instantPaymentConfirmMessage")}
        </h4>

        <div className="fg-tok-confirm-actions">
          <button
            type="button"
            className="btn fg-btn btn-outline-secondary fg-tok-confirm-btn-cancel"
            onClick={handleCancel}
            data-testid="payment-confirm-cancel"
          >
            {t("cancel")}
          </button>

          <button
            type="button"
            className="btn fg-btn fg-btn-filled-darkblue fg-tok-confirm-btn-proceed"
            onClick={onConfirm}
            data-testid="payment-confirm-proceed"
          >
            {t("instantPaymentConfirmProceed")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TokenisationConfirmModal;
